import { useEffect, useState } from "react";
import { App, Button, Card, Flex, Modal, Typography } from "antd";
import PlusIcon from "@/icons/PlusIcon";
import RequestUnitsTable from "@/components/tables/RequestUnitsTable";
import RequestUnitModal from "@/components/modals/RequestUnitModal";
import { getUnitsOptions } from "@/api/units";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { deleteUnit } from "@/api/requests";
import InfoCircleTooltip from "@/components/ui/InfoCircleTooltip";

const UnitsCard = ({
  requestUnits,
  loading,
  isDeleted,
  isHidden,
  isPublic = true,
  requestFormUuid,
  fetchData,
}) => {
  const { message } = App.useApp();
  const { confirm } = Modal;

  const [isUnitEditModal, setIsUnitEditModal] = useState(false);
  const [currentUnit, setCurrentUnit] = useState(null);

  const [freeUnits, setFreeUnits] = useState([]);

  useEffect(() => {
    const fetchUnits = async () => {
      try {
        const { units } = await getUnitsOptions();

        const requestUnitIds = new Set(
          (requestUnits || []).map((u) => u.unit_uuid),
        );

        const filteredUnits = units?.filter(
          (unit) => !requestUnitIds.has(unit.uuid),
        );

        setFreeUnits(filteredUnits);
      } catch (e) {
        console.log(e);
      }
    };

    fetchUnits();
  }, [requestUnits]);

  const handleAddUnit = () => {
    setCurrentUnit(null);
    setIsUnitEditModal(true);
  };

  const onCancel = () => {
    setIsUnitEditModal(false);
    setCurrentUnit(null);
  };

  const onSave = () => {
    setIsUnitEditModal(false);
    setCurrentUnit(null);
    fetchData();
  };

  const handleDeleteUnit = (item) => {
    confirm({
      title: `Вы уверены, что хотите открепить форму от группы ${item.unit_name}?`,
      icon: <ExclamationCircleFilled />,
      content:
        "Рабочая группа будет исключена из таблицы связанных с формой рабочих групп. Рабочая группа останется в общем списке рабочих групп.",
      onOk() {
        handleConfirmDeleteUnit({ uuid: item.uuid });
      },
      okText: "Удалить",
      cancelText: "Отмена",
    });
  };

  const handleConfirmDeleteUnit = async (item) => {
    try {
      await deleteUnit(item);
      fetchData();
    } catch (error) {
      message.open({
        type: "error",
        content: error.message,
        duration: 10,
      });
    }
  };

  const handleEditUnit = (item) => {
    setCurrentUnit(item);
    setIsUnitEditModal(true);
  };

  return (
    <Card
      type="small"
      title={
        <Typography.Title level={5} className="no-margin">
          <Flex gap={10} align="center">
            <span>Получатели заявок</span>
            <InfoCircleTooltip placement="top" size={20}>
              Рабочие группы, в которые могут направляться заявки
            </InfoCircleTooltip>
          </Flex>
        </Typography.Title>
      }
      extra={
        !isDeleted && (
          <Button type="primary" icon={<PlusIcon />} onClick={handleAddUnit} />
        )
      }
      style={{ boxShadow: "none" }}
    >
      <RequestUnitsTable
        data={requestUnits}
        loading={loading}
        onEditUnit={handleEditUnit}
        onDeleteUnit={handleDeleteUnit}
        requestUuid={requestFormUuid}
        isDeleted={isDeleted}
        isHidden={isHidden}
        isPublic={isPublic}
      />

      {isUnitEditModal && (
        <RequestUnitModal
          data={currentUnit}
          units={freeUnits}
          request_form_uuid={requestFormUuid}
          visible={isUnitEditModal}
          onCancel={onCancel}
          onSave={onSave}
        />
      )}
    </Card>
  );
};

export default UnitsCard;
